import { sectionRenderer } from '@theme/section-renderer';
import { ThemeEvents } from '@theme/events';

window.productPageCartItems = new Map();
window.productPageActiveInteractions = new Set();

document.addEventListener('DOMContentLoaded', async function () {
  const productForm = document.querySelector('product-form-component');
  if (!productForm) return;

  const form = productForm.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const variantIdInput = form.querySelector('input[name="id"]');
  const quantitySelector = form.querySelector('quantity-selector-component');
  const addToCartContainer = form.querySelector('add-to-cart-component');
  const addToCartTextError = form.querySelector('[ref="addToCartTextError"]');
  
  if (!variantIdInput || !quantitySelector || !addToCartContainer) return;

  const qtyControlsWrapper = document.createElement('div');
  qtyControlsWrapper.className = 'product-page__quantity-controls-wrapper';
  qtyControlsWrapper.style.display = 'none';
  
  qtyControlsWrapper.innerHTML = `
    <div class="product-page__quantity-controls">
      <button type="button" class="product-page__qty-btn product-page__qty-remove" data-action="remove">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 3H14M12.6667 3V13C12.6667 13.5304 12.4559 14.0391 12.0809 14.4142C11.7058 14.7893 11.1971 15 10.6667 15H5.33333C4.8029 15 4.29419 14.7893 3.91912 14.4142C3.54405 14.0391 3.33333 13.5304 3.33333 13V3M5.33333 3V2C5.33333 1.73478 5.43869 1.48043 5.62623 1.29289C5.81376 1.10536 6.06812 1 6.33333 1H9.66667C9.93188 1 10.1862 1.10536 10.3738 1.29289C10.5613 1.48043 10.6667 1.73478 10.6667 2V3M6.33333 7V11M9.66667 7V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <span class="product-page__qty-display">1</span>
      <button type="button" class="product-page__qty-btn product-page__qty-plus" data-action="increase">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  `;

  addToCartContainer.parentElement?.appendChild(qtyControlsWrapper);
  if (addToCartTextError) {
    qtyControlsWrapper.insertAdjacentElement('afterend', addToCartTextError);
  }

  const qtyControls = qtyControlsWrapper.querySelector('.product-page__quantity-controls');
  const qtyDisplay = qtyControls?.querySelector('.product-page__qty-display');
  const qtyRemove = qtyControls?.querySelector('.product-page__qty-remove');
  const qtyPlus = qtyControls?.querySelector('.product-page__qty-plus');

  let pendingApiCall = null;

  function showQuantityError(message) {
    if (!addToCartTextError) return;
    addToCartTextError.classList.remove('hidden');
    addToCartTextError.setAttribute('aria-live', 'polite');

    const textNode = addToCartTextError.childNodes[2];
    if (textNode) {
      textNode.textContent = message;
    } else {
      const newTextNode = document.createTextNode(message);
      addToCartTextError.appendChild(newTextNode);
    }
  }

  function getMaxQuantityErrorMessage(maxInventory) {
    if (!addToCartTextError) return '';
    const template = addToCartTextError.dataset.maxQuantityError || '';
    return template.replace('{{ max }}', String(maxInventory));
  }

  function hideQuantityError() {
    if (!addToCartTextError) return;
    addToCartTextError.classList.add('hidden');
    addToCartTextError.removeAttribute('aria-live');
  }

  function getMaxInventory() {
    const inventoryQuantity = parseInt(productForm.dataset.inventoryQuantity) || 0;
    const inventoryManaged = productForm.dataset.inventoryManaged === 'true';
    const inventoryPolicy = productForm.dataset.inventoryPolicy;
    
    if (inventoryManaged && inventoryPolicy === 'deny') {
      return inventoryQuantity;
    }
    return 9999;
  }

  function updateRemoveIcon(removeBtn, quantity) {
    if (!removeBtn) return;
    const svg = removeBtn.querySelector('svg');
    if (!svg) return;
    if (quantity > 1) {
      svg.innerHTML = '<path d="M3 8H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
    } else {
      svg.innerHTML = '<path d="M2 3H14M12.6667 3V13C12.6667 13.5304 12.4559 14.0391 12.0809 14.4142C11.7058 14.7893 11.1971 15 10.6667 15H5.33333C4.8029 15 4.29419 14.7893 3.91912 14.4142C3.54405 14.0391 3.33333 13.5304 3.33333 13V3M5.33333 3V2C5.33333 1.73478 5.43869 1.48043 5.62623 1.29289C5.81376 1.10536 6.06812 1 6.33333 1H9.66667C9.93188 1 10.1862 1.10536 10.3738 1.29289C10.5613 1.48043 10.6667 1.73478 10.6667 2V3M6.33333 7V11M9.66667 7V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
    }
  }

  async function loadCartState() {
    try {
      const timestamp = Date.now();
      const random = Math.random();
      const response = await fetch(`/cart.js?_=${timestamp}&r=${random}`, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'X-Requested-With': 'XMLHttpRequest'
        },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      window.productPageCartItems.clear();
      cart.items.forEach((item) => {
        window.productPageCartItems.set(String(item.variant_id), {
          quantity: item.quantity,
          key: item.key
        });
      });
    } catch (error) {}
  }

  function refreshCartDrawer() {
    try {
      const cartDrawer = document.querySelector('cart-drawer-component');
      const cartItemsComponent = cartDrawer?.querySelector('cart-items-component');
      if (cartItemsComponent && cartItemsComponent.dataset.sectionId) {
        const sectionId = cartItemsComponent.dataset.sectionId;
        sectionRenderer.renderSection(sectionId, { cache: false }).catch(() => {});
      }
    } catch (error) {}
  }

  function updateUI() {
    const variantId = variantIdInput.value;
    if (!variantId) return;
    
    if (window.productPageActiveInteractions.has(variantId)) return;

    const cartItem = window.productPageCartItems.get(variantId);
    const maxInventory = getMaxInventory();
    
    if (cartItem && cartItem.quantity > 0) {
      quantitySelector.style.display = 'none';
      addToCartContainer.style.display = 'none';
      qtyControlsWrapper.style.display = '';
      if (qtyDisplay) qtyDisplay.textContent = cartItem.quantity;
      if (qtyRemove) updateRemoveIcon(qtyRemove, cartItem.quantity);
      if (qtyPlus) {
        qtyPlus.disabled = maxInventory <= 0 || cartItem.quantity >= maxInventory;
      }
      if (maxInventory > 0 && cartItem.quantity >= maxInventory) {
        const message = getMaxQuantityErrorMessage(maxInventory);
        showQuantityError(message);
      } else {
        hideQuantityError();
      }
    } else {
      quantitySelector.style.display = '';
      addToCartContainer.style.display = '';
      qtyControlsWrapper.style.display = 'none';
      if (qtyPlus) qtyPlus.disabled = false;
      hideQuantityError();
    }
  }

  await loadCartState();
  updateUI();

  document.addEventListener(ThemeEvents.variantUpdate, async function(event) {
    if (event.detail && event.detail.resource) {
      const variant = event.detail.resource;
      if (variant.inventory_management === 'shopify') {
        productForm.dataset.inventoryQuantity = variant.inventory_quantity ?? 0;
        productForm.dataset.inventoryManaged = 'true';
        productForm.dataset.inventoryPolicy = variant.inventory_policy || 'deny';
      } else {
        productForm.dataset.inventoryManaged = 'false';
      }
    }

    if (event.detail?.data?.html) {
      const updatedProductForm = event.detail.data.html.querySelector('product-form-component');
      if (updatedProductForm) {
        if (updatedProductForm.dataset.inventoryQuantity) {
          productForm.dataset.inventoryQuantity = updatedProductForm.dataset.inventoryQuantity;
        }
        if (updatedProductForm.dataset.inventoryManaged) {
          productForm.dataset.inventoryManaged = updatedProductForm.dataset.inventoryManaged;
        }
        if (updatedProductForm.dataset.inventoryPolicy) {
          productForm.dataset.inventoryPolicy = updatedProductForm.dataset.inventoryPolicy;
        }
      }
    }
    await new Promise(resolve => setTimeout(resolve, 100));
    await loadCartState();
    updateUI();
  });

  // Listen to cart updates
  document.addEventListener(ThemeEvents.cartUpdate, async function(event) {
    await new Promise(resolve => setTimeout(resolve, 300));
    await loadCartState();
    updateUI();
  });

  // Intercept the add to cart submission
  const originalHandleSubmit = productForm.handleSubmit.bind(productForm);
  productForm.handleSubmit = function(event) {
    hideQuantityError();
    const variantId = variantIdInput.value;
    if (!variantId) return originalHandleSubmit(event);

    // Get quantity from quantity selector
    const qtyInput = quantitySelector?.querySelector('input[name="quantity"]');
    const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

    // Immediately update UI
    const cartItem = window.productPageCartItems.get(variantId) || { quantity: 0, key: '' };
    cartItem.quantity = quantity;
    window.productPageCartItems.set(variantId, cartItem);
    
    const maxInventory = getMaxInventory();
    quantitySelector.style.display = 'none';
    addToCartContainer.style.display = 'none';
    qtyControlsWrapper.style.display = '';
    if (qtyDisplay) qtyDisplay.textContent = String(quantity);
    if (qtyRemove) updateRemoveIcon(qtyRemove, quantity);
    if (qtyPlus && maxInventory <= quantity) {
      qtyPlus.disabled = true;
    }

    // Call original handler
    originalHandleSubmit(event);

    // Refresh cart drawer after a short delay
    setTimeout(() => {
      refreshCartDrawer();
    }, 500);
  };

  // Plus button handler
  if (qtyPlus) {
    qtyPlus.addEventListener('click', async function () {
      const variantId = variantIdInput.value;
      if (!variantId) return;

      const cartItem = window.productPageCartItems.get(variantId);
      if (!cartItem) return;

      const maxInventory = getMaxInventory();
      if (cartItem.quantity >= maxInventory) {
        qtyPlus.disabled = true;
        showQuantityError(
          'Atsižvelgiant į prekių likutį, į jūsų krepšelį pridėta tik 1 prekė.'
        );
        return;
      }
      hideQuantityError();

      window.productPageActiveInteractions.add(variantId);
      const newQty = cartItem.quantity + 1;
      if (qtyDisplay) qtyDisplay.textContent = String(newQty);
      if (qtyRemove) updateRemoveIcon(qtyRemove, newQty);
      cartItem.quantity = newQty;
      if (newQty >= maxInventory && qtyPlus) {
        qtyPlus.disabled = true;
      }

      if (pendingApiCall) clearTimeout(pendingApiCall);
      pendingApiCall = setTimeout(async () => {
        try {
          const currentDisplayedQty = parseInt(qtyDisplay?.textContent || String(newQty));
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variantId, quantity: currentDisplayedQty }),
          });
          if (!response.ok) {
            const errorPayload = await response.json().catch(() => null);
            if (errorPayload?.message) showQuantityError(errorPayload.message);
            throw new Error('Failed to update quantity');
          }
          cartItem.quantity = currentDisplayedQty;
          if (currentDisplayedQty >= maxInventory && qtyPlus) {
            qtyPlus.disabled = true;
          }
          refreshCartDrawer();
          document.dispatchEvent(new CustomEvent(ThemeEvents.cartUpdate, { bubbles: true }));
        } catch (error) {
          const revertedQty = Math.max(1, cartItem.quantity - 1);
          if (qtyDisplay) qtyDisplay.textContent = String(revertedQty);
          if (qtyRemove) updateRemoveIcon(qtyRemove, revertedQty);
          cartItem.quantity = revertedQty;
          if (qtyPlus) qtyPlus.disabled = false;
        }
        setTimeout(() => { window.productPageActiveInteractions.delete(variantId); }, 1000);
        pendingApiCall = null;
      }, 500);
    });
  }

  // Minus/Remove button handler
  if (qtyRemove) {
    qtyRemove.addEventListener('click', async function () {
      const variantId = variantIdInput.value;
      if (!variantId) return;

      const cartItem = window.productPageCartItems.get(variantId);
      if (!cartItem) return;

      const currentQty = cartItem.quantity;
      const newQty = currentQty - 1;

      const maxInventory = getMaxInventory();

      if (newQty <= 0) {
        if (qtyDisplay) qtyDisplay.textContent = '0';
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variantId, quantity: 0 }),
          });
          if (!response.ok) throw new Error('Failed to remove from cart');
          window.productPageCartItems.delete(variantId);
          qtyControlsWrapper.style.display = 'none';
          quantitySelector.style.display = '';
          addToCartContainer.style.display = '';
          if (qtyPlus) qtyPlus.disabled = false;
          refreshCartDrawer();
          document.dispatchEvent(new CustomEvent(ThemeEvents.cartUpdate, { bubbles: true }));
        } catch (error) {
          if (qtyDisplay) qtyDisplay.textContent = String(currentQty);
        }
      } else {
        if (qtyDisplay) qtyDisplay.textContent = String(newQty);
        updateRemoveIcon(qtyRemove, newQty);
        cartItem.quantity = newQty;
        if (newQty < maxInventory && qtyPlus) {
          qtyPlus.disabled = false;
        }

        if (pendingApiCall) clearTimeout(pendingApiCall);
        pendingApiCall = setTimeout(async () => {
          try {
            const currentDisplayedQty = parseInt(qtyDisplay?.textContent || String(newQty));
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: variantId, quantity: currentDisplayedQty }),
            });
            if (!response.ok) throw new Error('Failed to update quantity');
            cartItem.quantity = currentDisplayedQty;
            if (currentDisplayedQty < maxInventory && qtyPlus) {
              qtyPlus.disabled = false;
            }
            refreshCartDrawer();
            document.dispatchEvent(new CustomEvent(ThemeEvents.cartUpdate, { bubbles: true }));
          } catch (error) {
            const revertedQty = currentQty;
            if (qtyDisplay) qtyDisplay.textContent = String(revertedQty);
            updateRemoveIcon(qtyRemove, revertedQty);
            cartItem.quantity = revertedQty;
          }
          pendingApiCall = null;
        }, 500);
      }
    });
  }
});

